export enum ResponseCode {
  SUCCESS = 0,
  SESSION_EXPIRED = 2,
  FAIL_LOGIN_CHANGE = 4,
  WRONG_EMAIL_OR_PASSWORD = 16,
  USER_NOT_FOUND = 22,
  UNKNOWN_USER = 23,
  CANT_CREATE_SESSION = 24,
  NAME_IS_NOT_AVAILABLE = 25,
  NAME_IS_ALREADY_USED = 26,
  REQUIRED_PARAMETER_IS_MISSING = 27,
  BAD_PASSWORD = 28,
  NOT_FOR_PROMO = 60, //если promo игрок пытается записаться на тикетный турнир
  NO_MONEY = 65,
  OLD_VERSION_GAME = 75,
  LOGIN_IS_NOT_AVAILABLE = 76,
  NOT_AVAILABLE_NOW = 77,
  AN_ERROR_OCCURED = 78,
  AN_ERROR_OCCURED2 = 79,
  PASSWORD_CONFIRMATION_FAILED = 81,
  BAD_NEW_PASSWORD = 82,
  OLD_PASSWORD_DO_NOT_MATCH = 83,
  THIS_ACCOUNT_LOCKED = 85,
  MATCH_IS_NOT_FOUND = 101,
}

export enum StorageKeys {
  SESSION = 'session',
  LANGUAGE = 'language',
  PREFERENCES = 'preferences',
  CREATE_TABLE_OPTIONS = 'createTableOptions',
  TEMP_DATA = 'tempData',
  LAYOUT = 'layout',
}

export enum ModalConnectionError {
  BROWSER_NOT_SUPPORTED = 'BROWSER_NOT_SUPPORTED',
  GAME_SERVER_NOT_RESPONDING = 'GAME_SERVER_NOT_RESPONDING',
  PROXY_SERVER_NOT_RESPONDING = 'PROXY_SERVER_NOT_RESPONDING',
  GAME_SERVER_BROKE_CONNECTION = 'GAME_SERVER_BROKE_CONNECTION',
  incorrect_login_parameters = 'incorrect_login_parameters',
}

export enum TableOptionsKey {
  COST = 'cost',
  RATING_GAME = 'ratingGame',
  LADDER = 'ladder',
  INVITE_ONLY = 'inviteOnly',
  MIN_POINTS = 'minPoints',
  MAX_POINTS = 'maxPoints',
  NO_WATCHERS = 'noWatchers',
  TIME_PER_MOVE = 'timePerMove',
  GAME_COLOR = 'gameColor',
  TICKET_GAME = 'ticketGame',
  WITH_TIME_PER_MOVE = 'withTimePerMove',
  SIGNS = 'signs'
  //typeGame: 'custom',
}
export const ColorTheme = {
  GREEN: 't-green',
  BLUE: 't-blue',
};

export enum SocketCodes {
  CP_LOGIN = 127,
  CP_MESSAGE = 1,
  CP_TABLE_JOIN = 2,
  CP_TABLE_SERVE = 3,
  CP_PLAY = 4,
  CP_QUIT = 5,
  CP_PING = 6,
  CP_LAG = 7,
  CP_FINGER = 9,
  CP_SERVICE = 10,
  CP_INVITE = 12,
  CP_MOVE = 13,
  CP_ALIVE = 14,
  CP_TABLE_OP = 15,
  CP_GM_COMMAND = 16,
  CP_SET_LANGUAGE = 19,
  CP_GET_PROGRESS = 20,
  CP_CLIENT_VERSION = 21,

  SP_YOU_ARE = 127,
  SP_ERROR = 1,
  SP_JOIN = 2,
  SP_LEAVE = 3,
  SP_TABLE_OPT = 4,
  SP_TABLE_PLAYER = 5,
  SP_MESSAGE = 6,
  SP_GAME = 7,
  SP_MOVE = 8,
  SP_STAT = 9,
  SP_LAG = 10,
  SP_TABLE_LEAVE = 11,
  SP_WIN = 15,
  SP_FINGER = 21,
  SP_PROTOCOL_VERSION = 22,
  SP_INVITE = 23,
  SP_GAME_PROGRESS = 24,
  SP_TABLE_OWN = 25,
  SP_PLAYER_SWAP = 26,
  SP_ALIVE = 27,
  SP_COMMAND = 28,
  SP_DEAL = 29,
  SP_SCORE = 30,
  SP_MONEY = 31,
  SP_AVATAR = 32,
  SP_SCOMMAND = 34,
  SP_WIN2 = 35,
}

export const API_HOST = 'https://secure2.gamecolony.com/cgi-bin/';

export const UsStates = [
  {
    name: 'Select state',
    abbreviation: '',
  },
  {
    name: 'Alabama',
    abbreviation: 'AL',
  },
  {
    name: 'Alaska',
    abbreviation: 'AK',
  },
  {
    name: 'American Samoa',
    abbreviation: 'AS',
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
  },
  {
    name: 'California',
    abbreviation: 'CA',
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC',
  },
  {
    name: 'Federated States Of Micronesia',
    abbreviation: 'FM',
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
  },
  {
    name: 'Guam',
    abbreviation: 'GU',
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
  },
  {
    name: 'Marshall Islands',
    abbreviation: 'MH',
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
  },
  {
    name: 'New York',
    abbreviation: 'NY',
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
  },
  {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP',
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
  },
  {
    name: 'Palau',
    abbreviation: 'PW',
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR',
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
  },
  {
    name: 'Virgin Islands',
    abbreviation: 'VI',
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
  },
];
